import picRouter from './pic.router';
import pedidoVendas from './pedidoVendas.router';
import pedidosVendasPadrao from './pedidoVendasPadrao.router';

export default [
  ...picRouter,
  ...pedidoVendas,
  ...pedidosVendasPadrao,
];
